var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"custom-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.modelValue},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{staticClass:"checkmark"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }